import React, { Suspense, useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { LoggedInMobileGate } from './LoggedInMobileGate';
import { LoggedInMobileResultsPage } from './LoggedInMobileResultsPage';
import { LoggedInMobileUpgradePaywall } from './LoggedInMobileUpgradePaywall';
import { SelectSiteRoute } from './SelectSiteRoute';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { ConnectDomainRoute } from './ConnectDomainRoute';
import { ConnectIntroRoute } from './ConnectIntroRoute';
import { ConnectEntriRoute } from './ConnectEntriRoute';
import { ConnectErrorRoute } from './ConnectErrorRoute';
import { ConnectSuccessPage } from '@wix/my-domains-shared-components/@connect-success-page';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../../constants';
import { useQueryParams } from '../../hooks/useQueryParams';
const LoggedInSplitPage = /*#__PURE__*/React.lazy(() => import('./LoggedInSplitPage').then(m => ({
  default: m.LoggedInSplitPage
})));
const ScrollToTopOnNavigate = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
const ConnectSuccessRoute = () => {
  const {
    getQueryParam
  } = useQueryParams();
  const variant = getQueryParam('variant') ?? 'connected';
  return /*#__PURE__*/React.createElement(DomainsApiClient.Provider, null, /*#__PURE__*/React.createElement(ConnectSuccessPage, {
    siteDomain: getQueryParam('siteDomain') ?? '',
    siteName: getQueryParam('siteName') ?? '',
    siteId: getQueryParam('siteId') ?? undefined,
    variant: variant
  }));
};
export const LoggedInMobileGatePages = _ref => {
  var _getPremiumEssentials;
  let {
    handlers,
    onSelectSite,
    onSplitPageContinue,
    onSplitPageBack,
    onConnectEntri,
    onConnectIntro,
    onConnectManual,
    onUpgradeContinue,
    onManualConnectSuccess,
    onConnectEntriBack,
    onConnectIntroBack,
    onConnectErrorReturnToResults,
    onConnectError,
    externalViewer
  } = _ref;
  const loggedInMobileConnectEnabled = (_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.experiments) == null ? void 0 : _getPremiumEssentials[ExperimentSpecs.LoggedInMobileConnect];
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(DomainSearchGateModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(ScrollToTopOnNavigate, null), /*#__PURE__*/React.createElement(Switch, null, loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-manually",
    render: () => /*#__PURE__*/React.createElement(ConnectDomainRoute, {
      onManualConnectSuccess: onManualConnectSuccess
    })
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-entri",
    render: () => /*#__PURE__*/React.createElement(ConnectEntriRoute, {
      onBack: onConnectEntriBack,
      handlers: handlers,
      externalViewer: externalViewer
    })
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-success",
    render: () => /*#__PURE__*/React.createElement(ConnectSuccessRoute, null)
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-error",
    render: () => /*#__PURE__*/React.createElement(ConnectErrorRoute, {
      onReturnToResults: onConnectErrorReturnToResults
    })
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/connect-intro",
    render: () => /*#__PURE__*/React.createElement(ConnectIntroRoute, {
      onConnectEntri: onConnectEntri,
      onConnectManual: onConnectManual,
      onBack: onConnectIntroBack
    })
  }), loggedInMobileConnectEnabled && /*#__PURE__*/React.createElement(Route, {
    path: "/upgrade-paywall",
    render: () => /*#__PURE__*/React.createElement(LoggedInMobileUpgradePaywall, {
      onUpgradeContinue: onUpgradeContinue
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/select-site",
    render: () => /*#__PURE__*/React.createElement(SelectSiteRoute, {
      onSelectSite: onSelectSite,
      handlers: handlers,
      externalViewer: externalViewer,
      onConnectError: onConnectError,
      onConnectIntro: onConnectIntro,
      onConnectManual: onConnectManual
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/split-page",
    render: () => /*#__PURE__*/React.createElement(LoggedInSplitPage, {
      onContinue: onSplitPageContinue,
      onBack: onSplitPageBack
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/results",
    render: () => /*#__PURE__*/React.createElement(LoggedInMobileResultsPage, {
      handlers: handlers,
      externalViewer: externalViewer,
      onConnectIntro: onConnectIntro,
      onConnectManual: onConnectManual,
      onConnectError: onConnectError
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/",
    render: () => /*#__PURE__*/React.createElement(LoggedInMobileGate, {
      handlers: handlers
    })
  }))));
};
//# sourceMappingURL=LoggedInMobileGatePages.js.map